import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button, Tooltip } from 'src/common';
import styles from './index.module.scss';
import { useCreateSearchProfile, useUnusedColors } from '../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

export const CreateSearchProfile: FC = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const { data: unusedColors } = useUnusedColors();
  const [createSearchProfile] = useCreateSearchProfile();

  const onCancel = useCallback(() => {
    form.resetFields();
  }, [form]);

  const onSubmit = useCallback(() => {
    const title = form.getFieldValue('title');

    if (!unusedColors[0]) {
      form.setFields([
        {
          name: 'title',
          errors: [t('KeywordSearch.reachKeywordGroupsLimitMsg')]
        }
      ]);
      return;
    }
    createSearchProfile({
      name: title,
      onFinish: () => {
        onCancel();
      }
    });
  }, [t, form, unusedColors, createSearchProfile, onCancel]);

  return (
    <Form
      initialValues={{ title: '' }}
      layout={'vertical'}
      onFinish={onSubmit}
      form={form}
      className={styles.templateForm}
    >
      <Form.Item
        name="title"
        rules={[{ required: true, message: t('KeywordSearch.groupNameRequired') }]}
        className={styles.formItem}
      >
        <Input name="title" type="text" maxLength={30} placeholder={t('KeywordSearch.createSearchProfile')} />
      </Form.Item>
      <div className={styles.formFooter}>
        <Button type={'primary'} htmlType={'submit'}>
          {t('KeywordSearch.addGroup')}
        </Button>
        <Tooltip title={t('Common.cancel')}>
          <Button type={'text'} icon={<FontAwesomeIcon icon={faTimes} />} onClick={onCancel} />
        </Tooltip>
      </div>
    </Form>
  );
};
export default CreateSearchProfile;
